import Modal from '@Components/Shared/Modals/Modal';


const EnableQuickBidModal = (props) => {
    const onClose = () => {
        props?.onClose?.();
    };

    return (
        <Modal containerClassName='enable-quick-bid-modal' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={props.onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.quickbid')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>
                    <strong>
                        {translator.translate('sandhills.tradepubwebsite.mvc.enablequickbid').replace("<strong>", "").replace("</strong>", "")}
                    </strong>
                    <br />
                    {translator.translate('sandhills.tradepubwebsite.mvc.yourbidsimmediate2')} - {translator.translate('sandhills.tradepubwebsite.mvc.youwillreceivenoprompt').replace(/\{0\}/g, '"')}..
                    
                </span>
                <br />
                <br />
                <strong>{translator.translate('sandhills.tradepubwebsite.mvc.doyouwanttocontinue')}</strong>
                <br />
                <br />
                <input type='button' className='enable-quick-bid-modal-btn button ts-button' value={translator.translate('sandhills.tradepubwebsite.mvc.yesturnonquickbid')} onClick={props.onConfirm} />
                <input type='button' className='cancel-quick-bid-modal-btn button ts-button' value={translator.translate('sandhills.cancel')} onClick={props.onClose} />
            </Modal.Body>
        </Modal>
    );
}

export default EnableQuickBidModal;